module.exports = __webpack_public_path__ + "media/images/front/varieties/LANE-LATE-c0df85ee1aa47cfcc3c8d52eea41ce92.jpg";